//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Portal } from 'portal-vue'

const defaultInTransition = 'animate__fadeInDown'
const defaultOutTransition = 'animate__fadeOutUp'

export default {
  components: {
    Portal
  },
  data () {
    return {
      inTransition: defaultInTransition,
      outTransition: defaultOutTransition
    }
  },
  beforeMount () {
    if (window) {
      this.mediaQuery = window.matchMedia('(max-width: 480px)')
      this.mediaQuery?.addEventListener ? this.mediaQuery.addEventListener('change', this.mediaHandler) : this.mediaQuery.addListener(this.mediaHandler)

      if (this.mediaQuery.matches) {
        this.inTransition = 'animate__fadeInUp'
        this.outTransition = 'animate__fadeOutDown'
      }
    }
  },
  methods: {
    mediaHandler (e) {
      if (e.matches) {
        this.inTransition = 'animate__fadeInUp'
        this.outTransition = 'animate__fadeOutDown'
      } else {
        this.inTransition = defaultInTransition
        this.outTransition = defaultOutTransition
      }
    },
    close (...args) {
      /**
       * Клик на закрытии (крестик или подложка)
       */
      this.$emit('close', ...args)
    }
  }
}
